import { useEffect, useState } from 'react';

// Hook per sapere se siamo su mobile e aggiornarsi su ogni resize/orientation
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= breakpoint;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const update = () => {
      const matches = mediaQuery.matches;
      const widthCheck = window.innerWidth <= breakpoint;
      setIsMobile(matches || widthCheck);
    };

    // Aggiorna subito
    update();

    // Listener su media query (più efficiente) e fallback su resize/orientation
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', update);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(update);
    }

    const handleResize = () => {
      // Throttle naturale via RAF
      requestAnimationFrame(update);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', update);
      } else if (mediaQuery.removeListener) {
        mediaQuery.removeListener(update);
      }
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [breakpoint]);

  return isMobile;
}
